module.exports = require("@native-ads/antd/lib/button/button");


//////////////////
// WEBPACK FOOTER
// external "@native-ads/antd/lib/button/button"
// module id = 119
// module chunks = 0